import { gql } from '@efficiently/client-core-graphql-models';

export const SEND_CLIENT_LOG_BATCH_MUTATION = gql(`
	mutation SendClientLogBatch($payload: ClientLogBatchInput!) {
		sendClientLogBatch(payload: $payload)
	}
`);
